import { inject, Service } from '@angular/core';
import { ServicesService } from '../services';

@Service()
export class WordListEndpointService {
  readonly #service = inject(ServicesService);

  wordLists(arrangementCode: string) {
    return this.#service.vesta(`arrangement/${arrangementCode}/wordlists`);
  }

  wordList(arrangementCode: string, id: string, contentIdentifier: string) {
    return this.#service.vesta(
      `arrangement/${arrangementCode}/wordlists/${id}?contentIdentifier=${contentIdentifier}`,
    );
  }
}
